import React, { useState, useRef } from 'react';
import { Mutation } from '@apollo/client/react/components';
import {
  Dialog,
  DialogTitle,
  RadioGroup,
  Radio,
  DialogContent,
  DialogActions,
  FormControlLabel,
  IconButton,
  Button,
  Tooltip,
} from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import Loading from '../../../components/Loading';
import { UPDATE_TITLE_STATUS } from '../../../queries/titleContent';
import {
  WAITING,
  APPROVED,
  REPROVED,
  WORKING,
  REVISION,
  WAITPUBLISHING,
  PUBLISHED,
  ONHOLD,
} from '../../labels/labelsStatusContent';
import { StatusType } from '../../../enums/status-type.enum';
import { Toast } from '../../../components/Toast';

interface ISelectStatusProps {
  selectedTitles: Map<string, ITitle>;
  refetch: any;
}

const SelectStatus: React.FC<ISelectStatusProps> = ({
  selectedTitles,
  refetch,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedStatusId, setSelectedStatusId] = useState('');
  const [openLoading, setOpenLoading] = useState(false);
  const radioGroupRef = useRef<HTMLElement>();

  const handleEntering = () => {
    if (radioGroupRef.current) {
      radioGroupRef.current.focus();
    }
  };

  const handleClose = () => {
    setOpen(!open);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedStatusId(event.target.value);
  };

  const checkStatusWriter = (titles: Map<string, ITitle>, status: string) => {
    let valid = true;
    titles.forEach(async (title) => {
      if (!title.writerId && parseInt(status, 10) === StatusType.Approved) {
        valid = false;
      }
    });
    return valid;
  };

  const handleConfirm = (updateStatusTitle: any) => {
    setOpen(!open);
    if (!checkStatusWriter(selectedTitles, selectedStatusId)) {
      Toast(
        'Failed to update Titles! Approved Titles MUST have a Writer!',
        'warning',
      );
      return;
    }
    if (!selectedStatusId) return;
    setOpenLoading(true);
    try {
      selectedTitles.forEach(async (title) => {
        await updateStatusTitle({
          variables: { id: title.id, status: parseInt(selectedStatusId, 10) },
        });
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setOpenLoading(false);
      refetch();
    }
  };
  return (
    <Mutation mutation={UPDATE_TITLE_STATUS}>
      {(updateStatusTitle: any) => (
        <>
          <Tooltip title="Change status">
            <IconButton
              color="primary"
              aria-label="delete"
              onClick={(e) => {
                e.preventDefault();
                setOpen(true);
              }}
            >
              <CheckCircle />
            </IconButton>
          </Tooltip>

          <Loading openLoading={openLoading} />
          <Dialog
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="xs"
            onEntering={handleEntering}
            aria-labelledby="select-title-title"
            onClose={handleClose}
            open={open}
          >
            <DialogTitle id="select-title-title">Select a status</DialogTitle>
            <DialogContent dividers>
              <RadioGroup
                ref={radioGroupRef}
                aria-label="ringtone"
                name="ringtone"
                value={selectedStatusId}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio />}
                  label={WAITING}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label={APPROVED}
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label={REPROVED}
                />
                <FormControlLabel
                  value="4"
                  control={<Radio />}
                  label={WORKING}
                />
                <FormControlLabel
                  value="5"
                  control={<Radio />}
                  label={REVISION}
                />
                <FormControlLabel
                  value="6"
                  control={<Radio />}
                  label={WAITPUBLISHING}
                />
                <FormControlLabel
                  value="7"
                  control={<Radio />}
                  label={PUBLISHED}
                />
                <FormControlLabel
                  value="9"
                  control={<Radio />}
                  label={ONHOLD}
                />
              </RadioGroup>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => handleConfirm(updateStatusTitle)}
                color="primary"
                variant="contained"
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Mutation>
  );
};

export default SelectStatus;
